export default __webpack_public_path__ + "static/media/Asset 13.68f90668.png";